import { useState } from 'react';
import Reveal from '@/components/base/Reveal';

export default function Cta() {
  const [following, setFollowing] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <Reveal>
        <div className="relative overflow-hidden rounded-lg bg-primary-950 px-5 py-10 md:px-10 md:py-14">
          <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-500/10" />
          <div className="absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-secondary-500/10" />
          <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-xl">
              <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">长期关注入口</p>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                不错过任何一次剧情更新
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-100/75">
                无论是后续进展、当事人回应还是反转可能，只要事件还在走，在线黑料就会一直跟下去。留个记号，别让瓜停在半路。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => setFollowing((v) => !v)}
                className={`flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-medium transition-colors ${
                  following ? 'bg-secondary-500 text-background-50 hover:bg-secondary-600' : 'bg-accent-500 text-background-50 hover:bg-accent-600'
                }`}
              >
                <i className={`${following ? 'ri-check-line' : 'ri-add-line'} text-base`} />
                {following ? '已关注频道' : '关注频道'}
              </button>
              <button
                type="button"
                onClick={() => setBookmarked((v) => !v)}
                className={`flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-medium transition-colors ${
                  bookmarked ? 'bg-background-50 text-foreground-900' : 'bg-primary-700 text-background-100 hover:bg-primary-600'
                }`}
              >
                <i className={`${bookmarked ? 'ri-bookmark-fill' : 'ri-bookmark-line'} text-base`} />
                {bookmarked ? '已收藏本页' : '收藏本页'}
              </button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}